import i18n from '../../lib/reacti18n';
import * as types from '../constants/ActionTypes';
import { parseEmailForm, parseIpinfringementEmailWebform } from '../../lib/PPMEmailUtils';
import { emailWebFormTopicRefIds } from '../constants/UtilVariables';

const PAYPALME_REFID = 'PAYPALME001';

export const parserPayPalMeWebform = () => {
  const formFields = parseEmailForm();
  const refId = PAYPALME_REFID;
  const topicName = i18n.message('smarthelp/paypalmeForm.paypalform.violdation.header');

  return { formFields, refId, topicName };
};

// Provide PayPal.Me hardcode webform fields
export default () => (dispatch) =>
  dispatch({
    type: types.PROVIDE_PPM_EMAIL_FIELDS,
    payload: parserPayPalMeWebform(),
  });

/**
 * This function returns Ipinfingement form elements
 */
export const parseIpInfringementWebform = () => {
  const formFields = parseIpinfringementEmailWebform(); // getting the parsed email form
  const refId = emailWebFormTopicRefIds.ipInfringement;
  const topicName = i18n.message('smarthelp/emailUs.emailUs.infringement.introLabel');

  return { formFields, refId, topicName };
};
